export default "__VITE_ASSET__bee170f9__"